var map = {
  "./da.json": [
    "8960",
    [
      96089
    ]
  ],
  "./fi.json": [
    "58242",
    [
      54079
    ]
  ],
  "./sv.json": [
    "78770",
    [
      1327
    ]
  ],
  "./ja.json": [
    "29510",
    [
      19499
    ]
  ],
  "./lt.json": [
    "28967",
    [
      48268
    ]
  ],
  "./sl.json": [
    "31016",
    [
      88081
    ]
  ],
  "./fr.json": [
    "34683",
    [
      52104
    ]
  ],
  "./es.json": [
    "91375",
    [
      41476
    ]
  ],
  "./no.json": [
    "71076",
    [
      25573
    ]
  ],
  "./cs.json": [
    "32153",
    [
      35970
    ]
  ],
  "./en.json": [
    "77768",
    [
      7249
    ]
  ],
  "./description/en.json": [
    "4023",
    [
      66268
    ]
  ],
  "./pl.json": [
    "51939",
    [
      77024
    ]
  ],
  "./hu.json": [
    "18400",
    [
      20345
    ]
  ],
  "./nl.json": [
    "39537",
    [
      12714
    ]
  ],
  "./de.json": [
    "77148",
    [
      96813
    ]
  ],
  "./pt.json": [
    "87275",
    [
      33112
    ]
  ],
  "./it.json": [
    "82214",
    [
      52760
    ]
  ],
  "./et.json": [
    "29970",
    [
      20623
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 22362;
module.exports = __rspack_async_context;
